import React from 'react';
import TiptapContent from '../../TiptapContent';
import type { OriginEventRendererProps } from './types';
import { getReasonDoc, getReasonText } from './inOfficeHoldNote';

/**
 * Hold-2 ("in-office step needed"): the note ODO sent the practice
 * explaining why the in-office appointment is needed - plain text
 * (`reason`) or rich text (`reasonDoc`), validated before render exactly
 * like the legacy ScheduleAppointmentModal did. Same shape files-viewer's
 * ScheduleAppointmentTask reads off this event internally.
 */
const InOfficeHoldNoteContext: React.FC<OriginEventRendererProps> = ({ patientId, payload }) => {
    const reasonDoc = getReasonDoc(payload);
    const reasonText = getReasonText(payload);
    if (!reasonDoc && !reasonText) return null;

    return (
        <div className="text-sm text-amber-900">
            {reasonDoc ? (
                <TiptapContent doc={reasonDoc} patientId={patientId} />
            ) : (
                <p className="whitespace-pre-wrap">{reasonText}</p>
            )}
        </div>
    );
};

export default InOfficeHoldNoteContext;
